import { render, staticRenderFns } from "./EditSectionLink.vue?vue&type=template&id=a79e93f4"
import script from "./EditSectionLink.vue?vue&type=script&lang=js"
export * from "./EditSectionLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports